import React from 'react';

const SvgSn = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SN_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SN_svg__b" fill="#fff">
        <use xlinkHref="#SN_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#SN_svg__a" />
      <path fill="#F13642" mask="url(#SN_svg__b)" d="M13.333 0H28v20H13.333z" />
      <path fill="#17A052" mask="url(#SN_svg__b)" d="M0 0h9.333v20H0z" />
      <path
        fill="#FFF166"
        mask="url(#SN_svg__b)"
        d="M9.333 0h9.333v20H9.333z"
      />
      <path
        fill="#17A052"
        mask="url(#SN_svg__b)"
        d="M14 11.367l-1.96 1.33.66-2.275-1.87-1.452 2.367-.076L14 6.667l.803 2.227 2.367.076-1.87 1.452.66 2.275z"
      />
    </g>
  </svg>
);

export default SvgSn;
